import React, { useEffect, useState } from 'react';
import { ART_QUOTES } from '../lib/eggs';

// Typing "paint": splashes of paint burst across the screen, then a quote about art.
const COLORS = ['#e63946', '#f4a261', '#2a9d8f', '#457b9d', '#e9c46a', '#9b5de5', '#f15bb5'];

const blob = (seed) => {
  // an irregular splash outline
  let s = seed;
  const r = () => ((s = (s * 16807) % 2147483647) / 2147483647);
  const pts = Array.from({ length: 18 }, (_, i) => {
    const a = (i / 18) * Math.PI * 2, rad = 30 + r() * 22 + (i % 3 === 0 ? r() * 20 : 0);
    return `${50 + Math.cos(a) * rad},${50 + Math.sin(a) * rad}`;
  });
  return `M${pts.join(' L')} Z`;
};

const PaintSplash = ({ trigger }) => {
  const [run, setRun] = useState(null);
  useEffect(() => {
    if (!trigger) return undefined;
    const quote = ART_QUOTES[Math.floor(Math.random() * ART_QUOTES.length)];
    const splats = Array.from({ length: 9 }, (_, i) => ({
      x: 5 + Math.random() * 85, y: 5 + Math.random() * 80, size: 18 + Math.random() * 26,
      color: COLORS[i % COLORS.length], path: blob(i * 977 + trigger), delay: i * 70, rot: Math.random() * 360,
    }));
    setRun({ quote, splats, key: trigger });
    const t = setTimeout(() => setRun(null), 6500);
    return () => clearTimeout(t);
  }, [trigger]);
  if (!run) return null;
  return (
    <div key={run.key} className="fixed inset-0 z-[55] pointer-events-none overflow-hidden">
      <style>{`
        @keyframes splat { 0% { transform: scale(0) rotate(var(--r)); opacity: 0.95 } 25% { transform: scale(1.1) rotate(var(--r)) } 70% { opacity: 0.9 } 100% { transform: scale(1) rotate(var(--r)); opacity: 0 } }
        @keyframes quoteIn { 0% { opacity: 0; transform: translateY(12px) } 20%, 85% { opacity: 1; transform: none } 100% { opacity: 0 } }
      `}</style>
      {run.splats.map((s, i) => (
        <svg key={i} viewBox="0 0 100 100" style={{ position: 'absolute', left: `${s.x}%`, top: `${s.y}%`, width: `${s.size}vmin`, height: `${s.size}vmin`, '--r': `${s.rot}deg`, animation: `splat 4.5s ease-out ${s.delay}ms both` }}>
          <path d={s.path} fill={s.color} />
          <circle cx="88" cy="20" r="4" fill={s.color} />
          <circle cx="12" cy="85" r="3" fill={s.color} />
        </svg>
      ))}
      <div className="absolute inset-0 flex items-center justify-center p-6">
        <div className="max-w-lg text-center bg-white/90 backdrop-blur rounded-2xl shadow-2xl px-6 py-5" style={{ animation: 'quoteIn 6.2s ease both' }}>
          <p className="text-xl md:text-2xl font-serif italic text-gray-800 leading-snug">“{run.quote.text}”</p>
          <p className="mt-2 text-sm text-amber-800">— {run.quote.by}</p>
        </div>
      </div>
    </div>
  );
};

export default PaintSplash;
